import styled from 'styled-components';

import { aiAgentColors } from 'constants/aiAgentColors';

import { Button } from './Button';

export const GradientButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: linear-gradient(
    90deg,
    ${aiAgentColors.gradient.blue} 1%,
    ${aiAgentColors.gradient.lightBlue} 73%,
    ${aiAgentColors.gradient.green} 100%
  );

  &:hover {
    background: linear-gradient(
      90deg,
      ${aiAgentColors.gradient.hoverStart} 1%,
      ${aiAgentColors.gradient.hoverEnd} 100%
    );
  }
  &:active {
    background: linear-gradient(
      90deg,
      ${aiAgentColors.gradient.activeStart} 1%,
      ${aiAgentColors.gradient.activeEnd} 100%
    );
  }
`;
